const highlightValue = (value: string, searchQuery: string) => {
    const searchRegExp = new RegExp(`(${searchQuery})`, "gi");
    const renderTitle = searchQuery === "" ? value : value.replace(searchRegExp, "<b>$1</b>");
    return <span dangerouslySetInnerHTML={{ __html: renderTitle }} />
}
export { highlightValue };
